import React from 'react'

import { ReactComponent as CalendarIcon } from '../../../../../assets/icons/calendar-vet.svg'

import * as S from './styles'
const VaccineHistory = () => {
  return <>
    <S.Container>
      <S.WrapperHeader>
        <S.Title>Histórico de vacinas</S.Title>
        <S.Clip>Em breve</S.Clip>
      </S.WrapperHeader>
      <S.Body>
        <S.IconWrapper>
          <CalendarIcon />
        </S.IconWrapper>
        <S.TitleHistory>Acompanhe o calendário de vacinação dos seus pacientes</S.TitleHistory>
        <S.SubtitleHistory>Histórico das próximas aplicações e vacinações vencidas</S.SubtitleHistory>
      </S.Body>
    </S.Container>
  </>
}

export default VaccineHistory
